const vehicle_categoryRouter = [
    {
        path: "list-vehicle_category",
        name: "list",
        component: () => import("@/views/admin/vehicle_category"),
        default: true,
        meta: {
            model: "vehicle_category",
            // requiresAuth: true,
        },
    },
    {
        path: "list-vehicle_category/add",
        name: "add",
        component: () => import("@/views/admin/vehicle_category/function"),
        default: true,
        meta: {
            model: "vehicle_category",
            // requiresAuth: true,
        },
    },
    {
        path: "list-vehicle_category/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/vehicle_category/function"),
        default: true,
        meta: {
            model: "vehicle_category",
            // requiresAuth: true,
        },
    },
  ];
  export default vehicle_categoryRouter;